import { tns } from "../../../node_modules/tiny-slider";

export default () => {
    const slidersVideo = document.querySelectorAll('.slider-video');
    slidersVideo.forEach(element => {
        tns({
            container: element,
            loop: false,
            prevButton: element.parentNode.querySelector('.prevButtonVideo'),
            nextButton: element.parentNode.querySelector('.nextButtonVideo'),
            edgePadding: 0,
            nav: false,
            responsive:{
                0: {
                    items: 1
                }
            }
        });
    });

    const sliders = document.querySelectorAll('.slider');
    sliders.forEach(element => {
        tns({
            container: element,
            loop: false,
            prevButton: element.parentNode.querySelector('.prevButton'),
            nextButton: element.parentNode.querySelector('.nextButton'),
            edgePadding: 30,
            nav: false,
            responsive:{
                0: {
                    items: 1
                },
                550: {
                    items: 2
                },
                800:{
                    items:3
                }
            }
        });
    });
}
